import React from 'react';
import { Lock } from 'lucide-react';
import '../styles.css';

const LayersIcon = ({ className }: { className?: string }) => (
  <svg viewBox='0 0 100 100' fill='none' className={className}>
    {/* Top layer - yellow */}
    <path d='M50 20 L75 30 L75 40 L50 50 L25 40 L25 30 Z' fill='currentColor' />
    {/* Middle layer - slightly darker */}
    <path
      d='M50 40 L75 50 L75 60 L50 70 L25 60 L25 50 Z'
      fill='currentColor'
      opacity='0.7'
    />
    {/* Bottom layer - darkest */}
    <path
      d='M50 60 L75 70 L75 80 L50 90 L25 80 L25 70 Z'
      fill='currentColor'
      opacity='0.5'
    />
  </svg>
);

const TriadIcon = ({ className }: { className?: string }) => (
  <svg viewBox='0 0 100 100' fill='none' className={className}>
    {/* Left figure */}
    <circle
      cx='20'
      cy='40'
      r='10'
      stroke='currentColor'
      strokeWidth='5'
      fill='none'
    />
    <path
      d='M10 65 Q10 50 20 50 Q30 50 30 65'
      stroke='currentColor'
      strokeWidth='5'
      fill='none'
      strokeLinecap='round'
    />

    {/* Center figure - larger */}
    <circle
      cx='50'
      cy='35'
      r='13'
      stroke='currentColor'
      strokeWidth='6'
      fill='none'
    />
    <path
      d='M35 70 Q35 50 50 50 Q65 50 65 70'
      stroke='currentColor'
      strokeWidth='6'
      fill='none'
      strokeLinecap='round'
    />

    {/* Right figure */}
    <circle
      cx='80'
      cy='40'
      r='10'
      stroke='currentColor'
      strokeWidth='5'
      fill='none'
    />
    <path
      d='M70 65 Q70 50 80 50 Q90 50 90 65'
      stroke='currentColor'
      strokeWidth='5'
      fill='none'
      strokeLinecap='round'
    />
  </svg>
);

const AthenaAdvantageSection: React.FC = () => {
  return (
    <section className='advantage-section'>
      <div className='advantage-container'>
        <div className='advantage-header'>
          <h2>The Athena Advantage</h2>
        </div>

        <div className='advantage-grid'>
          {/* Large Featured Card - Secure by Design */}
          <div className='advantage-featured'>
            <div className='advantage-featured-blur' />

            <div className='advantage-featured-content'>
              <div className='advantage-featured-icon'>
                <Lock />
              </div>

              <h3>Secure by Design</h3>

              <p>
                Persistent workspaces with security controls built for sensitive
                environments - connecting researchers, warfighters and industry
                partners across institutional boundaries.
              </p>
            </div>
          </div>

          {/* Stacked Cards */}
          <div className='advantage-stacked'>
            {/* Single Interface Card */}
            <div className='advantage-card'>
              <div className='advantage-card-inner'>
                <div className='advantage-card-icon'>
                  <LayersIcon className='svg-icon' />
                </div>

                <div className='advantage-card-content'>
                  <h3>Single Interface</h3>
                  <p>
                    No more hunting through fragmented databases. One platform
                    connecting you to verified research, relevant experts and
                    ongoing projects across the defense landscape.
                  </p>
                </div>
              </div>
            </div>

            {/* Community Driven Card */}
            <div className='advantage-card'>
              <div className='advantage-card-inner'>
                <div className='advantage-card-icon'>
                  <TriadIcon className='svg-icon' />
                </div>

                <div className='advantage-card-content'>
                  <h3>Community Driven</h3>
                  <p>
                    Every feature reflects input from researchers, students and
                    partner organizations. Athena is a platform shaped by the
                    defense research community for real-world impact.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AthenaAdvantageSection;
